import { Col, FormControl, FormLabel, FormSelect, Row, Table } from "react-bootstrap";
import { useState } from "react";
import RollDice from "../dice-rolling";

export default function Artillery() {
	const [numRolls, setNumRolls] = useState(1);
	const [range, setRange] = useState(1);
	const [hits, setHits] = useState([-1, -1, -1, -1, -1, -1, -1]);

	const table: number[][] = [
		[1, 2, 2, 3, 3, 4, 5, 6, 7, 7],
		[1, 1, 2, 2, 3, 3, 4, 5, 6, 7],
		[1, 1, 1, 2, 2, 3, 4, 5, 6, 7]
	]

	function rollforHits() {
		const diceRolls: number[] = RollDice(numRolls);
		const currentTable: number[] = table[range - 1];
		let hitsContainer: number[] = [0, 0, 0, 0, 0, 0, 0];

		for (var i: number = 0; i < diceRolls.length; i++) {
			hitsContainer[currentTable[diceRolls[i] - 1] - 1]++;
		}

		setHits(hitsContainer);
	}

	return (
		<>
			<Row>
				<Col>
					<h1>Artillery Hits On Ships</h1>
				</Col>
			</Row>
			<Row className="">
				<Col>
					<Table striped bordered hover className="text-center">
						<thead>
							<tr>
								<th>Number of Hits</th>
								<th>Hit Result</th>
								<th>2nd</th>
								<th>3rd</th>
								<th>4th</th>
								<th>5th</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td className={hits[0] === 0 ? "text-success" : "text-danger"}>{hits[0] === -1 ? "" : hits[0]}</td>
								<td>Hull</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
							</tr>
							<tr>
								<td className={hits[1] === 0 ? "text-success" : "text-danger"}>{hits[1] === -1 ? "" : hits[1]}</td>
								<td>Oars</td>
								<td>Rowing Crew</td>
								<td>Deck Crew</td>
								<td>Hull</td>
								<td>-</td>
							</tr>
							<tr>
								<td className={hits[2] === 0 ? "text-success" : "text-danger"}>{hits[2] === -1 ? "" : hits[2]}</td>
								<td>Rowing Crew</td>
								<td>Oars</td>
								<td>Hull</td>
								<td>-</td>
								<td>-</td>
							</tr>
							<tr>
								<td className={hits[3] === 0 ? "text-success" : "text-danger"}>{hits[3] === -1 ? "" : hits[3]}</td>
								<td>Firepot</td>
								<td>Tower</td>
								<td>Artillery Crew</td>
								<td>Rowing Crew</td>
								<td>Hull</td>
							</tr>
							<tr>
								<td className={hits[4] === 0 ? "text-success" : "text-danger"}>{hits[4] === -1 ? "" : hits[4]}</td>
								<td>Archer</td>
								<td>Marine</td>
								<td>Deck Crew</td>
								<td>Rowing Crew</td>
								<td>Hull</td>
							</tr>
							<tr>
								<td className={hits[5] === 0 ? "text-success" : "text-danger"}>{hits[5] === -1 ? "" : hits[5]}</td>
								<td>Artillery</td>
								<td>Artillery Crew</td>
								<td>Hull</td>
								<td>-</td>
								<td>-</td>
							</tr>
							<tr>
								<td className={hits[6] === 0 ? "text-success" : "text-danger"}>{hits[6] === -1 ? "" : hits[6]}</td>
								<td>Marine</td>
								<td>Archer</td>
								<td>Artiller Crew</td>
								<td>Deck Crew</td>
								<td>Hull</td>
							</tr>
						</tbody>
					</Table>
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<FormLabel htmlFor="num-rolls">Number of Artillery Hits</FormLabel>
					<FormControl id="num-rolls" type="number" min={1} value={numRolls} onChange={(e) => setNumRolls(parseInt(e.target.value))} />
				</Col>
				<Col>
					<FormLabel htmlFor="range">Range</FormLabel>
					<FormSelect id="range" value={range} onChange={(e) => setRange(parseInt(e.target.value))}>
						<option value={1}>1</option>
						<option value={2}>2</option>
						<option value={3}>3+</option>
					</FormSelect>
				</Col>
			</Row>
			<Row className="mt-3">
				<Col xs={12}>
					<button className="btn btn-primary" onClick={() => rollforHits()}>Roll for Damage</button>
				</Col>
				<Col className="mt-3">
					<button className="btn btn-danger" onClick={() => setHits([-1, -1, -1, -1, -1, -1, -1])}>Clear Result</button>
				</Col>
			</Row>

		</>
	);
}